<template>
  <v-autocomplete
    v-model="selectedDriver"
    :items="driverState.list"
    :loading="driverState.loading"
    :search-input.sync="driverState.search"
    :disabled="disabled"
    item-text="displayLabel"
    item-value="id"
    return-object
    dense
    outlined
    clearable
    hide-details
    hide-no-data
    prepend-inner-icon="mdi-account"
    placeholder="Buscar conductor..."
    :filter="filterDrivers"
    @input="onInput"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.name }} {{ item.lastname }}</v-list-item-title>
        <v-list-item-subtitle>DNI: {{ item.document_number }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:selection="{ item }">
      <span class="caption text-truncate" style="max-width: 160px;">
        {{ item.name }} {{ item.lastname }}
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from 'lodash'
import DriverService from '../services/DriverService'

export default {
  name: 'DriverSelectorInline',

  props: {
    value: { type: Object, default: null },
    currentDealerId: { type: [String, Number], default: null },
    disabled: { type: Boolean, default: false }
  },

  data () {
    return {
      selectedDriver: this.value || null,
      driverState: {
        list: [],
        loading: false,
        search: ''
      }
    }
  },

  watch: {
    value (val) {
      this.selectedDriver = val
    },
    'driverState.search' (val) {
      if (val && val.length >= 3) this.debouncedSearch()
      else if (!val) this.driverState.list = []
    }
  },

  created () {
    this.loadInitial()
  },

  methods: {
    async loadInitial () {
      try {
        const params = { expand: 'dealer' }
        if (this.currentDealerId) params['filter[dealer_id]'] = this.currentDealerId
        const { data } = await DriverService.get(params)
        const list = data.data || []
        this.driverState.list = list.map(d => ({ ...d, displayLabel: `${d.name} ${d.lastname} — ${d.document_number}` }))
      } catch (e) { /* silencioso */ }
    },

    filterDrivers (item, queryText) {
      const text = `${item.name} ${item.lastname} ${item.document_number}`.toLowerCase()
      return text.includes(queryText.toLowerCase())
    },

    debouncedSearch: _.debounce(async function () {
      this.driverState.loading = true
      try {
        const params = {
          'filter[document_number]': this.driverState.search,
          expand: 'dealer'
        }
        if (this.currentDealerId) params['filter[dealer_id]'] = this.currentDealerId
        const { data } = await DriverService.get(params)
        const list = data.data || []
        this.driverState.list = list.map(d => ({ ...d, displayLabel: `${d.name} ${d.lastname} — ${d.document_number}` }))
      } catch (e) {
        this.driverState.list = []
      } finally {
        this.driverState.loading = false
      }
    }, 300),

    onInput (val) {
      this.$emit('input', val)
    }
  }
}
</script>
